import PropTypes from 'prop-types';

import './ContextMenuWrapper.scss';

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {
  children: <span />,
};

function ContextMenuWrapper({ children }) {
  return (
    <div className="ContextMenuWrapper" data-testid="context-menu">
      {children}
    </div>
  );
}

ContextMenuWrapper.propTypes = propTypes;
ContextMenuWrapper.defaultProps = defaultProps;

export default ContextMenuWrapper;
